<div class="message-list" #messagesList>
  @if (isMatchExpired && messages.length === 0) {
  <!-- Match expiré sans conversation -->
  <div class="conversation-ended">
    <div class="ended-icon">⏰</div>
    <h3>Match expiré</h3>
    <p>Ce match a expiré sans échange de messages.</p>
  </div>
  } @else if (isMatchCancelled && messages.length === 0) {
  <!-- Match annulé et pas de messages -->
  <div class="conversation-ended">
    <div class="ended-icon">😔</div>
    <h3>Conversation terminée</h3>
    <p>Cette conversation n'est plus active.</p>
  </div>
  } @else if (messages.length === 0) {
  <div class="empty-state">
    <div class="empty-icon">👋</div>
    <h3>Aucun message pour l'instant</h3>
    <p>Soyez le premier à briser la glace !</p>
  </div>
  } @else { @for (msg of messages; track $index) { @if (shouldShowDateSeparator($index)) {
  <div class="date-separator">
    <span>{{ getDateSeparatorLabel(msg.sentAt) }}</span>
  </div>
  }
  <div class="message-row" [ngClass]="{ me: msg.sender === myId, other: msg.sender !== myId }">
    @if (msg.sender !== myId) {
    <img
      [src]="
        (getParticipantById(msg.sender)?.imgUrl
          | versionedImageUrl : getParticipantById(msg.sender)?.profileImageUpdatedAt) ||
        'assets/img/default-avatar.png'
      "
      alt="avatar"
      loading="lazy"
    />
    }
    <div class="message-wrapper">
      <button
        type="button"
        class="bubble"
        [class.time-visible]="isMessageTimeVisible(msg, $index)"
        (click)="toggleMessageTime(msg, $index)"
        [attr.aria-expanded]="isMessageTimeVisible(msg, $index)"
        aria-label="Afficher ou masquer l'heure du message"
      >
        <span class="content">{{ msg.content }}</span>
      </button>
      @if (isMessageTimeVisible(msg, $index)) {
      <span class="time">{{ msg.sentAt | date : 'HH:mm' }}</span>
      }
    </div>
  </div>
  } }
</div>

<!-- Zone d'envoi de message OU bouton coup de cœur -->
@if (isMatchExpired && !isPermanent) {
<!-- Match expiré : zone désactivée avec possibilité de supprimer -->
<div class="conversation-expired-notice">
  <div class="expired-icon">⏰</div>
  <p>Ce match a expiré</p>
</div>
<div class="send-box disabled">
  <textarea placeholder="Match expiré" disabled></textarea>
  <button type="button" disabled>
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
    </svg>
  </button>
</div>
} @else if ( isConversationEnded && !isPermanent && !isMatchCancelled && isHeartWindowExpired ) {
<!-- Conversation expirée ET fenêtre 12h passée : conversation définitivement terminée -->
<div class="conversation-expired-notice">
  <div class="expired-icon">⏰</div>
  <p>Conversation expirée, vous ne pouvez plus discuter avec cette personne</p>
</div>
<div class="send-box disabled">
  <textarea placeholder="Conversation expirée" disabled></textarea>
  <button type="button" disabled>
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
    </svg>
  </button>
</div>
} @else if (isConversationEnded && !isPermanent && !isMatchCancelled) {
<!-- Conversation expirée mais fenêtre 12h active : afficher le bouton coup de cœur -->
<div class="heart-request-box">
  @if (isPermanent) {
  <div class="heart-status success">
    <span class="heart-icon">💕</span>
    <span>Match permanent !</span>
  </div>
  } @else if (heartRequestStatus?.sentByMe && heartRequestStatus?.receivedFromOther) {
  <div class="heart-status success">
    <span class="heart-icon">💕</span>
    <span>Coup de cœur confirmé !</span>
  </div>
  } @else if (heartRequestStatus?.sentByMe) {
  <div class="heart-status sent">
    <span class="heart-icon">💜</span>
    <span>Coup de cœur envoyé !</span>
  </div>
  } @else if (heartRequestStatus?.canSend) {
  <button
    type="button"
    class="heart-request-btn vertical"
    (click)="sendHeartRequestClicked.emit()"
    [disabled]="heartRequestSending"
  >
    @if (heartRequestSending) {
    <span class="loading">Envoi...</span>
    } @else {
    <div class="heart-title">
      <span>Envoyer un coup de cœur !</span>
      <span class="heart-icon">💜</span>
    </div>
    <span class="countdown">{{ heartRequestCountdown }}</span>
    }
  </button>
  } @else if (heartRequestStatus) {
  <div class="heart-status expired">
    <span>Fenêtre de coup de cœur expirée</span>
  </div>
  } @else {
  <div class="heart-status loading">
    <span>Chargement...</span>
  </div>
  }
</div>
} @else if (isMatchCancelled) {
<!-- Match annulé : zone désactivée -->
<div class="send-box disabled">
  <textarea placeholder="Conversation terminée" disabled></textarea>
  <button type="button" disabled>
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
    </svg>
  </button>
</div>
} @else {
<!-- Conversation normale -->
<div class="send-box">
  <textarea
    [(ngModel)]="newMessage"
    placeholder="Écrire un message..."
    (keydown)="onEnterPress($event)"
    #messageInput
    rows="1"
    maxlength="1000"
  ></textarea>
  <button type="button" (click)="sendMessage()" [disabled]="!newMessage.trim()">
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
    </svg>
  </button>
</div>
}
